<template>
  <profile-card title="Video Gallery">
    <VideoLightBox ref="lightbox" :media="videoItems" :show-light-box="false"></VideoLightBox>
    <form @submit.prevent="post">
      <div class="cp-field">
        <div class="form-row">
          <div class="form-group col">
            <h5>Title</h5>
            <input type="text" v-model="title" class="form-control"/>
          </div>
        </div>
      </div>
      <div class="cp-field">
        <file-pond
          name="test"
          ref="pond"
          v-model="video"
          label-idle="Drop video here..."
          v-bind:allow-multiple="false"
          :files="video"
          accepted-file-types="video/mp4"
          maxFileSize="100MB"
        />
      </div>
      <div class="cp-field">
        <div class="form-row">
          <div class="form-group col">
            <!--<switch-btn
                    label="The video is related to one of my tasks"
                    switch_id="dfsdfsd"
                    label_style="margin: 20px 0 -15px 0;"
                    v-model="checked"
            ></switch-btn>-->
            <div class="my-switch-btn">
              <div>The video is related to one of my tasks</div>
              <input type="checkbox" id="video_task_switch" v-model="checked"/>
              <label for="video_task_switch">Toggle</label>
            </div>
          </div>
        </div>
      </div>

      <trader-done-tasks
        v-if="checked"
        container_style="float: left;width: 100%;margin-top: 29.4px;padding: 0 20px;"
        v-model="task_id"
      ></trader-done-tasks>

      <div class="save-stngs pd2">
        <ul>
          <li>
            <button class="ps-btn ps-btn--sm" type="submit" style="margin-top:14px;">Save</button>
          </li>
        </ul>
      </div>
      <div v-if="loading" class="cp-field">
        <div class="form-row">
          <div class="form-group col">
            <label>
              <loading
                :active="loading"
                :can-cancel="false"
                loader="dots"
                color="#2292ef"
                :is-full-page="false"
              ></loading>
            </label>
          </div>
        </div>
      </div>
      <!--save-stngs end-->
      <div v-else class="container">
        <table class="table table-bordered" style="margin-bottom:10px;">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Preview</th>
              <th scope="col">Name</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(vid, i) in videos" :key="i">
              <td scope="row" style="width:80px;">{{ i + 1 }}</td>
              <td style="width:100px;">
                <img
                  @click="showVideo(i)"
                  :src="vid.thumbnail"
                  width="100"
                  :title="vid.title"
                  style="cursor:pointer;"
                />
              </td>
              <td>
                <div
                  @click.prevent="
											openTitleEditor(vid.id, vid.title)
										"
                  v-if="editedVideoId != vid.id"
                >{{ vid.title }}
                </div>
                <div v-else>
                  <input
                    @keypress.enter.prevent="
												editVideoTitle(
													vid.id,
													editedTitle
												)
											"
                    style="border: 1px solid #ccc;border-radius: 5px;margin-top: 13px;"
                    v-model="editedTitle"
                  />
                  <i
                    @click.prevent="
												editVideoTitle(
													vid.id,
													editedTitle
												)
											"
                    class="fa fa-check"
                    style="margin-left:2px;cursor:pointer;"
                  ></i>
                  <i
                    @click.prevent="
												openTitleEditor(
													vid.id,
													vid.title
												)
											"
                    class="fa fa-times"
                    style="margin-left:2px;cursor:pointer;"
                  ></i>
                </div>
              </td>
              <td style="width:80px;" class="table-kqr">
                <a
                  href="#"
                  @click.prevent="
											openTitleEditor(vid.id, vid.title)
										"
                >
                  <i class="fa fa-edit"></i>
                </a>
                <a @click.prevent="deleteVideo(vid.id)" href="#">
                  <i class="fa fa-trash"></i>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </form>
  </profile-card>
</template>

<script>

  // Import VueLightBox
  import VideoLightBox from './VideoLightBox'

  require('vue-image-lightbox/dist/vue-image-lightbox.min.css')

  // Import Vue FilePond
  import vueFilePond from "vue-filepond";

  // Import FilePond styles
  import "filepond/dist/filepond.min.css";

  // Import FilePond plugins
  // Please note that you need to install these plugins separately

  // Import image preview plugin styles
  import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";

  // Import image preview and file type validation plugins
  import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
  import FilePondPluginImagePreview from "filepond-plugin-image-preview";
  import FilePondPluginFileEncode from "filepond-plugin-file-encode";
  import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';

  // Create component
  const FilePond = vueFilePond(
    FilePondPluginFileValidateType,
    FilePondPluginImagePreview,
    FilePondPluginFileEncode,
    FilePondPluginFileValidateSize
  );
  import SwitchBtn from "nice-switch-btn";
  import TraderDoneTasks from "./../../../TraderDoneTasks";
  import Loading from "vue-loading-overlay";
  import "vue-loading-overlay/dist/vue-loading.css";

  export default {
    components: {
      VideoLightBox,
      SwitchBtn,
      TraderDoneTasks,
      Loading
    },
    props: {},
    data() {
      return {
        errors: null,
        video: this.video,
        checked: false,
        task_id: null,
        title: "",
        editedTitle: "",
        videos: [],
        videoItems: [],
        videoIndex: null,
        editedVideoId: null,
        loading: false
      };
    },
    mounted() {
      this.updatePage();
    },
    methods: {
      openTitleEditor: function (id, title) {
        if (this.editedVideoId == id) {
          this.editedVideoId = null;
          this.editedTitle = "";
        } else {
          this.editedVideoId = id;
          this.editedTitle = title;
        }
      },
      editVideoTitle: function (id, title) {
        let data = {
          title: title
        };
        this.$Progress.start();
        let self = this;
        axios({
          method: "post",
          url: "/dashboard/video/" + id + "?_method=patch",
          data
        })
          .then(function (res) {
            if (res.data.ok) {
              self.$Progress.finish();
              self.updatePage();
              self.$toast.success(res.data.msg);
            } else {
              self.$Progress.fail();
              self.$toast.error(res.data.msg);
            }
          })
          .catch(function (err) {
            self.$Progress.fail();
          });
        this.editedVideoId = null;
        this.editedTitle = "";
      },
      deleteVideo: function (id) {
        let self = this;
        self.$Progress.start();
        axios({
          method: "post",
          url: "/dashboard/video/" + id + "?_method=delete"
        })
          .then(function (res) {
            if (res.data.ok) {
              self.$Progress.finish();
              self.updatePage();
              self.$toast.success(res.data.msg);
            } else {
              self.$Progress.fail();
              self.$toast.error(res.data.msg);
            }
          })
          .catch(function (err) {
            self.$Progress.fail();
            console.log(err);
          });
      },
      post: function () {

        if (this.video[0].status === 8) {
          this.$toast.error("Invalid File", {
            queue: true
          });
          return;
        }

        let video = [];
        this.video.forEach(function (vid) {
          video.push(vid.getFileEncodeDataURL());
        });
        this.$Progress.start();
        let self = this;
        let data = {
          video: video,
          task_id: self.task_id,
          title: self.title
        };
        axios({
          method: "post",
          url: "/dashboard/video",
          data
        })
          .then(function (res) {
            if (res.data.ok) {
              self.$Progress.finish();
              self.$toast.success(res.data.msg);

              self.updatePage();
            } else {
              self.$Progress.fail();
              self.$toast.error(res.data.msg);
            }
          })
          .catch(function (err) {
            self.$Progress.fail();
            console.log(err);
            if (err.response.status == 422) {
              let errors = err.response.data.errors;
              self.errors = errors;
              for (let error in errors) {
                self.$toast.error(errors[error][0]);
              }
            }
            if (err.response.status == 403) {
              if (err.response.data.type && err.response.data.type === 'canFeatureValidation') {
                window.subscriptionRequired()
              }else{
                self.$toast.error(err.response.data.message);
              }
            }

          });
      },
      updatePage: function () {
        let self = this;
        self.$Progress.start();
        self.loading = true;
        this.video = null;
        this.checked = false;
        this.task_id = null;
        this.title = "";
        this.videoItems = [];
        axios({
          method: "get",
          url: "/dashboard/video"
        })
          .then(function (res) {
            if (res.data.ok) {
              self.$Progress.finish();
              self.loading = false;
              self.videos = res.data.videos;
              self.setVideoItems(self.videos);
            } else {
              self.$Progress.fail();
            }
          })
          .catch(function (err) {
            self.$Progress.fail();
            self.loading = false;
            console.log(err);
          });
      },
      setVideoItems: function (videos) {
        let self = this;
        videos.forEach(function (video) {
          let item = {};
          item.thumb = video.thumbnail;
          item.sources = [];
          item.sources[0] = {};
          item.sources[0].src = video.source;
          item.sources[0].type = 'video/mp4';
          item.type = 'video';
          item.caption = '';
          item.width = 800;
          item.height = 600;
          item.autoplay = false;
          self.videoItems.push(item);
        });
      },
      showVideo(index) {
        if (this.videos.length) {
          this.$refs.lightbox.showImage(index);
        }
      },
    }
  };
</script>
<style scoped>
  .my-switch-btn input[type="checkbox"] {
    height: 0;
    width: 0;
    visibility: hidden;
  }

  .my-switch-btn label {
    cursor: pointer;
    text-indent: -9999px;
    width: 67px;
    height: 33px;
    background: grey;
    display: block;
    border-radius: 100px;
    position: relative;
  }

  .my-switch-btn label:after {
    content: "";
    position: absolute;
    top: 4px;
    left: 5px;
    width: 29px;
    height: 25px;
    background: #fff;
    border-radius: 90px;
    transition: 0.3s;
  }

  .my-switch-btn input:checked + label {
    background: #bada55;
  }

  .my-switch-btn input:checked + label:after {
    left: calc(100% - 5px);
    transform: translateX(-100%);
  }

  .my-switch-btn label:active:after {
    width: 40px;
  }
</style>
